module.exports = __webpack_public_path__ + "static/media/comebacksoon.fc3b60ee.jpg";